<div class="card">
    <div class="card-header card-no-border">
        <div class="header-top">
            <h5 class="m-0">Nouveaux candidats qualifiés</h5>
            <div class="card-header-right-icon">
                <div>
                    <a 
                       class="btn btn-primary" type="button"><i class="icon-eye"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body pt-0 campaign-table custom-mb-1">
        <div class="recent-table table-responsive currency-table">
            <table class="table">
                <thead>
                <tr>
                    <th class="f-light"></th>
                    <th class="f-light">Nom et prénoms</th>
                    <th class="f-light">Domaine</th>
                    <th class="f-light">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of usersAdmin">
                    <td class="border-icon {{ item.colorClass }}">
                        <div>
                            <img class="img-fluid img-40 rounded-circle" src="assets/images/dashboard/user/4.jpg" alt="user"/>
                            
                        </div>
                    </td>
                    <td>{{ item.firstName }} {{ item.lastName }}</td>
                    <td><span class="badge  badge-primary">{{ item.username }}</span></td>
                    <td> 
                        <div ngbDropdown class="d-inline-block">
                            <button
                              class="btn btn-primary dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-haspopup="false"
                              aria-expanded="true"
                              ngbDropdownToggle
                            >
                              Actions
                            </button>
                            <div class="dropdown-menu" ngbDropdownMenu>
                              
                              <a
                                class="dropdown-item"
                                ngbDropdownItem
                                href="javascript:void(0)"
                                (click)="showDialog(item._id)"
                                >Voir Plus</a
                              >
                            </div>
                          </div>
                         </td>
                    
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
